document.addEventListener("DOMContentLoaded", function () {
  const form = document.querySelector(".bf-banner .newsletter-form__form");
  if (!form) return;

  const newsletterRoot = form.closest(".newsletter-form");
  const bannerRoot = form.closest(".bf-banner");
  const nameInput = form.querySelector(".newsletter-form__name");
  const emailInput = form.querySelector(".newsletter-form__email");
  const successMsg = form.querySelector(".newsletter-form__success");
  const errorMsg = form.querySelector(".newsletter-form__error");
  const whatsappBtn = form.querySelector(".newsletter-form__whatsapp");
  const submitBtn = form.querySelector(
    'button[type="submit"], .newsletter-form__buttons .button:not(.newsletter-form__whatsapp)'
  );

  const setPending = (isPending) => {
    if (!submitBtn) return;
    submitBtn.disabled = isPending;
    if (isPending) {
      submitBtn.setAttribute("aria-busy", "true");
    } else {
      submitBtn.removeAttribute("aria-busy");
    }
  };

  const resetSuccess = () => {
    form.classList.remove("is-success");
    newsletterRoot?.classList.remove("is-success");
    bannerRoot?.classList.remove("is-signup-success");
    successMsg?.classList.add("hidden");
    setPending(false);
  };

  const hideError = () => {
    errorMsg?.classList.add("hidden");
  };

  const showError = () => {
    resetSuccess();
    errorMsg?.classList.remove("hidden");
  };

  const showSuccess = () => {
    hideError();
    form.classList.add("is-success");
    newsletterRoot?.classList.add("is-success");
    bannerRoot?.classList.add("is-signup-success");
    successMsg?.classList.remove("hidden");
    form.reset();
    setPending(false);
  };

  // Fresh page loads and bfcache restores must always show the form again.
  resetSuccess();
  window.addEventListener("pageshow", (event) => {
    if (event.persisted) resetSuccess();
  });

  if (whatsappBtn) {
    whatsappBtn.addEventListener("click", () => {
      const configuredUrl = (
        whatsappBtn.getAttribute("data-whatsapp-url") || ""
      ).trim();

      if (configuredUrl) {
        window.open(configuredUrl, "_blank", "noopener,noreferrer");
        return;
      }

      const phone = "4917647056710";
      const encodedMessage = encodeURIComponent(whatsappBtn.dataset.message || "");
      window.open(
        "https://api.whatsapp.com/send/?phone=" + phone + "&text=" + encodedMessage,
        "_blank",
        "noopener,noreferrer"
      );
    });
  }

  [nameInput, emailInput].forEach((input) => {
    input?.addEventListener("input", hideError);
  });

  form.addEventListener("submit", function (e) {
    e.preventDefault();

    if (form.classList.contains("is-success") || submitBtn?.disabled) {
      return;
    }

    const name = nameInput?.value.trim() || "";
    const email = (emailInput?.value || "").trim().toLowerCase();

    hideError();

    if (!email || !window.SmilodoxSaleSignup?.subscribeToSaleList) {
      showError();
      return;
    }

    setPending(true);

    window.SmilodoxSaleSignup.subscribeToSaleList({
      email,
      name,
      customSource: "Shopify BF Banner",
    })
      .then(() => {
        showSuccess();
      })
      .catch((error) => {
        if (error?.status != null || error?.body != null) {
          console.error("[SmilodoxSaleSignup] Klaviyo subscription failed", {
            status: error.status,
            body: error.body,
          });
        } else {
          console.error("[SmilodoxSaleSignup] Klaviyo subscription failed", error);
        }
        setPending(false);
        showError();
      });
  });
});
